import React from 'react'
import { useTranslation } from 'react-i18next'
import { useEnvironment } from '@hooks/useEnvironment'
import { DrawerContentBody, DrawerContentFooter, DrawerContentHeader } from '@components/ui-css/Drawer'
import { CssModuleContext } from '@components/stylesContext/context'
import { InteractionContext } from '@components/interactionContext/context'
import { SVGIcon } from '@components/ui-css/SVGIcon'
import { RetryButton } from './components/RetryButton'
import { ContactUsPanel } from './components/ContactUsPanel'
import styles from './styles/Error.module.scss'

const Error: React.FC = () => {
  const { translationNamespace } = useEnvironment()
  const { t } = useTranslation(translationNamespace, { keyPrefix: 'ErrorPage' })

  return (
    <InteractionContext.Provider value={{ name: 'insurance-panel', type: 'technical-error' }}>
      <CssModuleContext.Provider value={styles}>
        <DrawerContentHeader>
          <span className={styles.title}>{t('header.title')}</span>
        </DrawerContentHeader>
        <DrawerContentBody className={styles.bodyContainer}>
          <div className={styles.body}>
            <SVGIcon library="base" name="clock" />
            <span className={styles.content}>{t('body.content')}</span>
            <RetryButton />
          </div>
        </DrawerContentBody>
        <DrawerContentFooter>
          <div className={styles.footer}>
            <ContactUsPanel />
            <span className={styles.disclaimer}>{t('footer.disclaimer')}</span>
          </div>
        </DrawerContentFooter>
      </CssModuleContext.Provider>
    </InteractionContext.Provider>
  )
}

export default Error
